import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import {
  Container, Row, Col, Form, Card, CardBody,
  FormGroup, Input, Label, Button, FormFeedback,
  Modal, ModalBody, ModalHeader, ModalFooter,
  TabContent, TabPane, Nav, NavItem, NavLink,
} from 'reactstrap'
import classnames from 'classnames'
import Select from 'react-select'
import _ from 'lodash'

import DeleteConfirmation from 'components/Modal/deleteConfirmation'
import Lang from 'Lang/General'

const CreateRecipientGroupForm = ( props ) => {
  const langButton = [ 'en', 'de', 'es', 'it', 'fr', 'nl' ]
  const [ selectedTitleLang, setLangTitle ] = useState( 'en' )
  const [ activeTab, updateActiveTab ] = useState( '1' )

  const onChangeData = ( key, value ) => {
    let tmp = _.cloneDeep( props.newRecipientGroup )
    let dataKey = ''
    tmp[key] = value

    props.onChangeRecipientGroupHOC( 'newRecipientGroup', tmp )
  }

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      updateActiveTab( tab )
    }
  }

  return(
    <Modal
      isOpen={ props.showCreateRecipientGroup }
      size="xl">
      <ModalHeader toggle={ () => props.onChangeRecipientGroupHOC( 'showCreateRecipientGroup', false ) }>{ Lang['CREATE_RECIPIENT_GROUP'][ props.dataReducer.languageReducer.userSettings.admin_panel_language ] }</ModalHeader>
      <ModalBody>
        <Container className="mt-3 mb-5">
          <Row>
            <Col md={ 12 }>
              <Card>
                <CardBody>
                  <Form>
                    <FormGroup>
                      <Label for="funnel_title" sm={ 2 }>{ Lang['NAME'][ props.dataReducer.languageReducer.userSettings.admin_panel_language ] } <span style={{ color: 'red'}}>*</span></Label>
                      <div className="d-flex pt-1">
                        {
                          langButton.map( button => {
                            return(
                              <Button
                                className="btn-square btn-wide mr-0" size="sm"
                                color={ `${ selectedTitleLang === button ? 'primary' : 'light' }` }
                                onClick={ () => setLangTitle( button ) }>{ button }</Button>
                            )
                          })
                        }
                      </div>
                      <Input
                        name="funnel_title" id="funnel_title"
                        placeholder={ Lang[ 'NAME' ][ props.dataReducer.languageReducer.userSettings.admin_panel_language ] }
                        value={ props.newRecipientGroup.name[selectedTitleLang] }
                        onChange={ e => {
                          let tmp = {}
                          tmp[selectedTitleLang] = e.target.value

                          onChangeData( 'name', tmp )
                        }}
                        />
                    </FormGroup>
                    <FormGroup>
                      <Label for="status">{ Lang[ 'STATUS' ][ props.dataReducer.languageReducer.userSettings.admin_panel_language ] }</Label>
                      <Input
                        type="select"
                        name="status"
                        id="status"
                        invalid={ /*errorMessage && errorMessage.status ? true :*/ false }
                        value={ props.newRecipientGroup.status }
                        onChange={ e => onChangeData( 'status', e.target.value ) }>
                        <option>{ Lang[ 'ACTIVE' ][ props.dataReducer.languageReducer.userSettings.admin_panel_language ] }</option>
                        <option>{ Lang[ 'INACTIVE' ][ props.dataReducer.languageReducer.userSettings.admin_panel_language ] }</option>
                      </Input>
                      <FormFeedback>{ /*errorMessage && errorMessage.status ? errorMessage.status : '' */}</FormFeedback>
                    </FormGroup>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </ModalBody>
      <ModalFooter>
        <Button className="mr-2" color="primary" onClick={ () => props.createRecipientGroup( props.newRecipientGroup ) }>{ Lang[ 'SUBMIT' ][ props.dataReducer.languageReducer.userSettings.admin_panel_language ] }</Button>
      </ModalFooter>
    </Modal>
  )
}

const mapStateToProps = state => ({ dataReducer: state })
export default connect( mapStateToProps )( CreateRecipientGroupForm )
